import { defineStore } from 'pinia';
import { ref } from 'vue';
import { getProgramDashboardReportCounts, getReportYears, getProgramDashboardReportStatusCounts, getProgramDashboardOrganizationCounts } from '../services/programLambda';
import { BASE_STORAGE_KEY } from '@/utils/constants';

const STORAGE_KEY = `${BASE_STORAGE_KEY}:dashboard`;

export const useProgramDashboardStore = defineStore(STORAGE_KEY, () => {
  // State
  const reportCounts = ref(null);
  const availableYears = ref([]);
  const reportStatusCounts = ref(null);
  const organizationCounts = ref(null);
  const selectedReportYear = ref(null);


  // Actions
  async function fetch() {    
    const reportYears = await getReportYears();
    availableYears.value = reportYears.map(year => ({
      label: year.reportYear,
      value: year.reportYear,
    }));

    if (availableYears.value.length > 0) {
      selectedReportYear.value = availableYears.value[0].value;
      const [counts, orgCounts, statusCounts] = await Promise.all([
        getProgramDashboardReportCounts(),
        getProgramDashboardOrganizationCounts(),
        getProgramDashboardReportStatusCounts(selectedReportYear.value)
      ]);
      reportCounts.value = counts;
      organizationCounts.value = orgCounts;
      reportStatusCounts.value = statusCounts;
    }
  }

  async function fetchReportStatusCounts() {
    reportStatusCounts.value = await getProgramDashboardReportStatusCounts(selectedReportYear.value);
  }

  return {
    reportCounts,
    availableYears,
    reportStatusCounts,
    organizationCounts,
    selectedReportYear,

    fetch,
    fetchReportStatusCounts,
  };
});